import { handleExport } from 'src/utils';

import { exportJobService } from 'services';

export const exportSmartLink = async (token: string, linkId: number): Promise<void> => {
  const [status, response] = await exportJobService.exportSmartLink(token);

  if (!status) {
    return;
  }

  const { id } = response.data.data;

  handleExport({
    id,
    estimatedLoadingTime: 3,
    fileName: `SmartLink.${id}`,
    onRetry: () => exportSmartLink(token, linkId),
  });
};
